module.exports = __webpack_public_path__ + "static/img/2.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/2.jpg
// module id = RYWd
// module chunks = 36